module.exports = __webpack_public_path__ + "static/media/rs-in.9d90f40f.svg";